import React, { useMemo } from 'react';
import useSWR from 'swr';
import { useTheme } from '../../../contexts/ThemeContext';
import { fetcher } from '../../../services/fetcher';
import type { CrewStatisticsResponse } from '../../crew/types';
import { StatCounterGrid, type StatCounterItem } from './shared';

function todayIso(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

const CrewCertGaps: React.FC<{ embedded?: boolean; settings?: Record<string, unknown> }> = ({
  embedded,
}) => {
  const { colors } = useTheme();
  const today = todayIso();
  const url = `/crew/reports/statistics?withinDays=90&periodFrom=${encodeURIComponent(today)}&periodTo=${encodeURIComponent(today)}`;
  const { data, isLoading } = useSWR<CrewStatisticsResponse>(url, fetcher, { revalidateOnFocus: true });

  const counters: StatCounterItem[] = useMemo(() => {
    const kpis = data?.kpis;
    return [
      {
        key: 'certs-expired',
        label: 'Certs expired',
        value: kpis?.certsExpired ?? 0,
        href: '/crew/statistics/compliance/certs-expired',
        accent: 'bg-rose-500',
      },
      {
        key: 'certs-expiring',
        label: 'Certs expiring',
        value: kpis?.certsExpiring ?? 0,
        href: '/crew/statistics/compliance/certs-expiring',
        accent: 'bg-amber-500',
      },
      {
        key: 'medicals-expired',
        label: 'Medicals expired',
        value: kpis?.medicalsExpired ?? 0,
        href: '/crew/statistics/compliance/medicals-expired',
        accent: 'bg-rose-600',
      },
      {
        key: 'medicals-due',
        label: 'Medicals due',
        value: kpis?.medicalsExpiring ?? 0,
        href: '/crew/statistics/compliance/medicals-due',
        accent: colors.accent,
      },
    ];
  }, [colors.accent, data?.kpis]);

  return (
    <StatCounterGrid
      title="Crew · Compliance"
      counters={counters}
      isLoading={isLoading}
      embedded={embedded}
      viewAllPath="/crew/statistics/compliance/certs-expired"
    />
  );
};

export default CrewCertGaps;
